import React, { useState, useEffect, useContext } from 'react';
import { Col, Row } from 'components/Core/Grid';
import { navigate } from 'gatsby';
import DownloadSplashPosts from '../Posts';
import DownloadableContentFilters from '../Filter';
import { jobStageData } from '../static/data';
import { Container } from './styles';
import Pagination from 'components/Core/Pagination';
import SweetScrollContext from 'utils/SweetScrollContext';

const DownloadableSplashPosts = ({ industry, type, stage, pageNumber, posts }) => {
  const [currentPage, setCurrentPage] = useState(pageNumber);
  const postsPerPage = 6;
  const hubType = type.toLowerCase();
  const { scrollToAnchor } = useContext(SweetScrollContext);

  const filteredPostsByIndustry = () =>
    industry ? posts.filter((post) => post.seo?.taxonomy?.industries?.[0] === industry) : posts;

  const [filteredPosts, setFilteredPosts] = useState([...filteredPostsByIndustry()]);
  const [postsToShow, setPostsToShow] = useState([
    ...filteredPosts.slice((currentPage - 1) * postsPerPage, currentPage * postsPerPage),
  ]);

  const [jobStage, setJobStage] = useState(stage || 'all');

  const totalPages = Math.ceil(filteredPosts.length / postsPerPage);

  useEffect(() => {
    setPostsToShow([
      ...filteredPosts.slice((currentPage - 1) * postsPerPage, currentPage * postsPerPage),
    ]);
  }, [currentPage, filteredPosts]);

  useEffect(() => {
    setFilteredPosts([...filteredPostsByIndustry()]);
  }, [industry]);

  useEffect(() => {
    let filteredPostsByJobStage = filteredPostsByIndustry();

    if (jobStage && jobStage !== 'all') {
      filteredPostsByJobStage = filteredPostsByJobStage.filter(
        (post) => post.jobStage === jobStageData[jobStage].label,
      );
    }
    setFilteredPosts(filteredPostsByJobStage);
  }, [jobStage]);

  const handleFilterUpdate = (value) => {
    const path = `/${type.toLowerCase()}/${value === 'All-Industries' ? '' : value.toLowerCase()}`;
    const state = { jobStage };

    navigate(path, { state });
  };

  const handleJobStageUpdate = (newStage) => {
    setJobStage(newStage);
  };

  const getPostsShowingString = () => {
    return `${currentPage * postsPerPage - postsPerPage + 1}-${
      currentPage * postsPerPage < filteredPosts.length
        ? currentPage * postsPerPage
        : filteredPosts.length
    }`;
  };

  return (
    <Container>
      <Row gutter={40} type="flex" id="card-group">
        <Col xs={24} sm={24} md={8}>
          <DownloadableContentFilters
            posts={posts}
            type={type}
            jobStage={jobStage}
            handleFilterUpdate={handleFilterUpdate}
            handleJobStageUpdate={(value) => handleJobStageUpdate(value)}
            isTypeSplash
            industry={industry}
            pageInfo={
              filteredPosts.length > 0
                ? `Showing ${getPostsShowingString()} of ${filteredPosts.length}`
                : ''
            }
          />
        </Col>
        <Col xs={24} sm={24} md={16}>
          <div className="download-posts-container--title-container">
            {type === 'Templates' ? (
              <p className="download-posts-container--job-stage-desktop">
                {jobStage && jobStageData[jobStage]?.icon && (
                  <div className="download-posts-container--job-stage-icon">
                    <img src={jobStageData[jobStage]?.icon} alt={jobStageData[jobStage]?.label} />
                  </div>
                )}
                <p>{`${jobStageData[jobStage]?.label || 'All Stages of The Job'}`}</p>
              </p>
            ) : (
              <div />
            )}
            <span className="download-posts-container--post-count-desktop">
              {filteredPosts.length > 0
                ? `Showing ${getPostsShowingString()} of ${filteredPosts.length}`
                : ''}
            </span>
          </div>
          <Row gutter={[40, 40]} type="flex">
            {postsToShow.length ? (
              postsToShow
                .slice(0, postsPerPage)
                .map((post, index) => <DownloadSplashPosts type={type} post={post} key={index} />)
            ) : (
              <Col xs={24} sm={24}>
                <p className="text-[18px]">
                  No templates were found that match the search criteria.
                </p>
              </Col>
            )}
          </Row>
          {totalPages > 1 && (
            <Pagination
              className="pt-10"
              template={hubType}
              pageContext={{ currentPage, numPages: totalPages }}
              onPage={(i, e) => {
                if (e) {
                  e.preventDefault();
                }
                if (hubType) {
                  window.history.pushState({}, '', `/${hubType}/page/${i}`);
                }
                setCurrentPage(i);
                scrollToAnchor('#card-group');
                return false;
              }}
            />
          )}
        </Col>
      </Row>
    </Container>
  );
};

export default DownloadableSplashPosts;
